<template>
  <div class="mains">
    <div class="campus">
      教务管理
      <span>></span>
      <router-link to="staff">员工管理</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">员工管理</div>
          <el-button type="primary" class="buttons" @click="xinjian">
            <span>+</span> 新建员工
          </el-button>
          <el-dialog title="新建员工" :visible.sync="dialogTableVisible" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="员工账号" prop="username">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form.username" placeholder="请输入您的员工账号"></el-input>
                </el-form-item>
                <div class="genggai">
                  （ 用于登陆后台管理系统，不可二次更改 ）
                </div>
                <el-form-item label="员工姓名" prop="name">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
                </el-form-item>
                <el-form-item label="员工角色" prop="rolecode">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-dropdown>
                    <el-button type="primary" class="xuanze1">
                      {{ xuanze1 }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu class="dropdownss" slot="dropdown">
                      <el-dropdown-item @click.native="guanli1(item)" v-for="(item, index) in xuanzejuese" :key="index">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="性别" class="xingbie1">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-radio-group v-model="form.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="所在班级" prop="classid">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-dropdown class="banji">
                    <el-button type="primary" class="xuanze1 yangs">
                      <span :class="yang ? 'yang1' : 'yang2'" v-for="(item, index) in list" :key="index">
                        {{ item.name }}
                        <img src="@/assets/img/education-manage/staff/cha.png" :class="yang ? 'yang11' : 'yang22'" @click="guanli3(item.id)" />
                      </span>
                    </el-button>
                    <el-dropdown-menu class="dropdownsss" slot="dropdown">
                      <el-dropdown-item @click.native="guanli2(item, index)" v-for="(item, index) in banji1" :key="index" :class="{ yang1_2: index == current }">
                        {{ item.name }}
                        <img :src="yang ? src : srcs" class="yang1_1" />
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form.phone" placeholder="请输入您的联系方式"></el-input>
                </el-form-item>
                <el-form-item label="个人邮箱" prop="email">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="form.email" placeholder="请输入您的个人邮箱"></el-input>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="queding">确定</el-button>
                  <el-button @click="quxiao">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="编辑员工" :visible.sync="dialogTableVisibles" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="forms" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="员工账号" prop="username">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms.username" readonly placeholder="请输入您的员工账号" class="jinzhishuru"></el-input>
                </el-form-item>
                <el-form-item label="员工姓名" prop="name">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms.name" placeholder="请输入您的姓名"></el-input>
                </el-form-item>
                <el-form-item label="员工角色" prop="rolecode">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-dropdown>
                    <el-button type="primary" class="xuanze1">
                      {{ xuanze3 }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu class="dropdownss" slot="dropdown">
                      <el-dropdown-item @click.native="guanli1_1(item)" v-for="(item, index) in xuanzejuese" :key="index">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="性别" class="xingbie1">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-radio-group v-model="forms.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="所在班级" prop="classid">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-dropdown class="banji">
                    <el-button type="primary" class="xuanze1 yangs">
                      <span :class="yang_1 ? 'yang1' : 'yang2'" v-for="(item, index) in lists" :key="index">
                        {{ item.name }}
                        <img src="@/assets/img/education-manage/staff/cha.png" :class="yang_1 ? 'yang11' : 'yang22'" @click="guanli3_1(item.id)" />
                      </span>
                    </el-button>
                    <el-dropdown-menu class="dropdownsss" slot="dropdown">
                      <el-dropdown-item @click.native="guanli2_1(item, index)" v-for="(item, index) in banji1" :key="index" :class="{ yang1_2: index == current }">
                        {{ item.name }}
                        <img :src="yang_1 ? src : srcs" class="yang1_1" />
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms.phone" placeholder="请输入您的联系方式"></el-input>
                </el-form-item>
                <el-form-item label="个人邮箱" prop="email">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                  </i>
                  <el-input v-model="forms.email" placeholder="请输入您的个人邮箱"></el-input>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="queding1">确定</el-button>
                  <el-button @click="quxiao1">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="修改密码" :visible.sync="dialogTableVisibless" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="formss" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="原密码" prop="oldPassword">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt class="sangezi" />
                  </i>
                  <el-input type="password" v-model="formss.oldPassword" placeholder="请输入您的原先密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" alt class="sangezi" />
                  </i>
                  <el-input type="password" v-model="formss.newPassword" placeholder="请输入您的新密码"></el-input>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="empUpdatePwd">确定</el-button>
                  <el-button @click="quxiao2">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <el-dialog title="员工信息" :visible.sync="dialogTableVisiblesss" width="600px">
            <el-row class="chakanss">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  员工账号：
                  <span>{{ formsss.username }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  员工姓名：
                  <span>{{ formsss.name }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row class="chakanss">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  员工性别：
                  <span>{{ formsss.sex }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  员工角色：
                  <span>{{ formsss.rolecode }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row class="chakanss">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  联系方式：
                  <span>{{ formsss.phone }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  个人邮箱：
                  <span>{{ formsss.email }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row class="chakanss">
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  所在班级：
                  <span v-for="(item, index) in formsss.classList" :key="index">{{ item.name }}</span>
                </div>
              </el-col>
            </el-row>
          </el-dialog>
          <div class="sousuo">
            <span>角色：</span>
            <el-dropdown>
              <el-button type="primary" class="xuanze">
                {{ xuanze }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="dropdowns" slot="dropdown">
                <el-dropdown-item @click.native="guanli(item), chaxun(item)" v-for="(item, index) in xuanzejuese" :key="index">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span>员工账号：</span>
            <el-input v-model="orgname" @keyup.13.native="chaxun" placeholder="请输入员工账号或员工昵称"></el-input>
            <el-button type="primary" class="buttons" @click="chaxun()">查 询</el-button>
          </div>
          <div class="zsbg">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="username" label="员工账号" max-width="360">
                <template slot-scope="scope">
                  <el-link @click="chakan(scope.row.id)">{{
                    scope.row.username
                  }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="员工姓名" min-width="40"></el-table-column>
              <el-table-column prop="rolename" label="员工角色"></el-table-column>
              <el-table-column prop="phone" label="联系方式"></el-table-column>
              <el-table-column prop="showCreateTime" label="创建时间"></el-table-column>
              <el-table-column label="账号状态">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.booleanAccountstatus" active-color="#07C160" inactive-color="#E5E5E5" @change="
                      zhuangtai(
                        scope.row.booleanAccountstatus,
                        scope.row.id,
                        scope.row.userid
                      )
                    "></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="stData">
                  <!--<el-button type="text">APP下载页</el-button>-->
                  <el-button type="text" class="caozuo" @click="xuigai(stData.row.userid)">修改密码</el-button>
                  <el-button type="text" class="caozuo" @click="getEduTeacherById(stData.row.id)">编辑</el-button>
                  <el-button type="text" class="caozuo" @click="del(stData.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>
    <div class="juese xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">角色权限</div>
          <div class="zsbg zsbg1">
            <el-table :data="tableDatas" border style="width: 100%">
              <el-table-column prop="name" label="角色" min-width="40" max-width="300px"></el-table-column>
              <el-table-column prop="data" label="用户权限"></el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'staff',
  data() {
    return {
      orgname: '',
      tableData: [],
      tableDatas: [
        {
          name: '管理员',
          data: '即学校的校长，学校总负责人；具有所有的管理功能。可创建并管理校区、学科，及所有其它角色。'
        },
        {
          name: '教务老师',
          data: '主要负责管理班级、学员、课程、教材等日常教务教学工作，具有教学教务相关模块的全部权限。'
        },
        {
          name: '学管师',
          data: '学员的学习管理者，跟踪学员整个学习过程，协调家校沟通，促进续费。'
        },
        {
          name: '教师',
          data: '主要负责给学员上课，以及准备课程教学内容、布置并检查学员的课后作业等。'
        }
      ],
      form: {
        username: '',
        name: '',
        rolecode: '',
        sex: '1',
        classid: '',
        phone: '',
        email: ''
      },
      forms: {},
      formss: {
        oldPassword: '',
        newPassword: ''
      },
      formsss: {},
      jiaoshi: true,
      FormRules: {
        username: [{ required: true, message: '请您填写必填信息' }],
        name: [{ required: true, message: '请您填写必填信息' }],
        rolecode: [{ required: this.rolecode ? 'true' : 'false', message: '请您填写必填信息1' }],
        // sex: [
        //   { required: true, message: '请您填写必填信息' }
        // ],
        classid: [{ required: true, message: '请您填写必填信息' }],

        phone: [
          { required: true, message: '请您填写必填信息' },
          { pattern: /^1[35789]\d{9}$/, message: '账号格式不对' }
        ],
        email: [{ required: true, message: '请您填写必填信息' }]
      },
      xuanze: '选择角色',
      xuanze1: '选择角色',
      xuanze2: '选择角色',
      xuanze3: '选择角色',
      xuanze1_1: '',
      xuanze1_2: '',
      yang: true,
      yang_1: false,
      src: require('@/assets/img/education-manage/staff/dui_b.png'),
      srcs: require('@/assets/img/education-manage/staff/dui_l.png'),
      list: [{ name: '请选择您所在的班级（可多选）', id: '' }],
      lists: [],
      xuanzejuese: [],
      gridData: [],
      banji1: [],
      banji2: [],
      dialogTableVisible: false,
      dialogTableVisibles: false,
      dialogTableVisibless: false,
      dialogTableVisiblesss: false,
      // 检索表单数据对象
      page: 1,
      pageSize: 5,
      currentPage: 1,
      total: 0,
      current: 9999,
      xuigaimima: ''
    };
  },
  mounted() {
    this.juese();
    this.chaxun();
    // this.guanli()
    // this.zhuangtai()
  },
  watch: {
    xuanze1() {
      this.form.rolecode = this.xuanze1_1;
      // console.log(this.form.sex)
    },
    xuanze3() {
      this.forms.rolecode = this.xuanze1_2;
      // console.log(this.form.sex)
    },
    list: {
      handler(newValue, oldValue) {
        // console.log(newValue)
        if (this.list.length === 1) {
          this.form.classid = this.list[0].id;
          // console.log(str)
        } else {
          var str = '';
          str = this.list
            .map(function(elem, index) {
              return elem.id;
            })
            .join('&#');
          this.form.classid = str;
        }
      },
      deep: true
    },
    lists: {
      handler(newValue, oldValue) {
        // console.log(newValue)
        if (this.lists.length === 1) {
          this.forms.classid = this.lists[0].id;
          // console.log(str)
        } else {
          var str = '';
          str = this.lists
            .map(function(elem, index) {
              return elem.id;
            })
            .join('&#');
          this.forms.classid = str;
        }
      },
      deep: true
    }
  },
  methods: {
    queding() {
      // console.log(this.form.classid)
      this.$refs.forms.validate(valid => {
        if (!valid) {
          return false;
        }
        var that = this.form;
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let orgid = window.sessionStorage.getItem('orgid');
        let pro = this.$http({
          url: '/edu/teacher/addTeacher',
          method: 'POST',
          data: {
            orgid: orgid,
            username: that.username,
            name: that.name,
            rolecode: that.rolecode,
            sex: that.sex,
            classids: that.classid,
            phone: that.phone,
            email: that.email
          },
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.dialogTableVisible = false;
            this.chaxun();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('新建员工失败：' + err);
          });
      });
    },
    queding1() {
      // console.log(this.forms)
      this.$refs.forms.validate(valid => {
        if (!valid) {
          return false;
        }
        var that = this.forms;
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let pro = this.$http({
          url: '/edu/teacher/updateTeacher',
          method: 'POST',
          data: {
            orgid: that.orgid,
            id: that.id,
            userid: that.userid,
            name: that.name,
            rolecode: that.rolecode,
            sex: that.sex,
            classids: that.classid,
            phone: that.phone,
            email: that.email
          },
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // console.log('123')
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            // this.guanli2_1()
            this.dialogTableVisibles = false;
            this.chaxun();
          })
          .catch(err => {
            console.log(err);
            return this.$message.error('修改员工失败：' + err);
          });
      });
    },
    quxiao() {
      this.dialogTableVisible = false;
    },
    quxiao1() {
      this.dialogTableVisibles = false;
    },
    quxiao2() {
      this.dialogTableVisibless = false;
    },
    getEduTeacherById(id) {
      // console.log(id)
      this.dialogTableVisibles = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/teacher/getEduTeacherById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.forms = result.data.data;
          this.forms.sex = JSON.stringify(this.forms.sex);
          for (var i = 0; i < this.xuanzejuese.length; i++) {
            if (this.forms.rolecode === this.xuanzejuese[i].code) {
              this.xuanze3 = this.xuanzejuese[i].name;
            }
          }
          this.banji();
          this.lists = this.forms.classList;
          // console.log(this.forms)
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获取修改员工信息失败：' + err);
        });
    },
    chakan(id) {
      // console.log(id)
      this.dialogTableVisiblesss = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/teacher/getEduTeacherById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.formsss = result.data.data;
          if (this.formsss.sex === 0) {
            this.formsss.sex = '女';
          } else if (this.formsss.sex === 1) {
            this.formsss.sex = '男';
          }
          for (var i = 0; i < this.xuanzejuese.length; i++) {
            if (this.formsss.rolecode === this.xuanzejuese[i].code) {
              this.formsss.rolecode = this.xuanzejuese[i].name;
            }
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('查看员工信息失败：' + err);
        });
    },
    empUpdatePwd() {
      // console.log(this.xuigaimima)
      var that = this.formss;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/teacher/empUpdatePwd',
        method: 'POST',
        data: {
          userid: this.xuigaimima,
          oldPassword: that.oldPassword,
          // oldPassword: '',
          newPassword: that.newPassword
          // newPassword: ''
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code === 0) {
            this.dialogTableVisibless = false;
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('修改密码失败：' + err);
        });
    },
    xuigai(id) {
      this.dialogTableVisibless = true;
      this.xuigaimima = id;
    },
    banji() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/teacher/selectClassListByOrgid',
        method: 'POST',
        data: {
          orgid: orgid
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.banji1 = result.data.data;
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得角色失败：' + err);
        });
    },
    juese() {
      let pro = this.$http({
        url: '/edu/teacher/getRoleList',
        method: 'GET'
      });
      pro
        .then(result => {
          this.xuanzejuese = result.data.roleList;
          // console.log(this.xuanzejuese)
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得角色失败：' + err);
        });
    },
    chaxun(e) {
      var code = '';
      if (e !== undefined) {
        code = e.code;
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/teacher/selectTeacherPage',
        method: 'POST',
        data: {
          orgid: orgid,
          username: this.orgname,
          rolecode: code,
          page: this.page,
          pageSize: this.pageSize
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          console.log(result.data);
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          var data = result.data.data;
          this.tableData = data;
          if (data === undefined || data === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('获得员工列表失败：' + err);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      // this.$options.methods.chaxun()
      this.chaxun();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.chaxun();
    },
    zhuangtai(index, id, ids) {
      // console.log(ids)
      // 确认事情
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/teacher/updateEduTeacherAccountStatus',
        method: 'POST',
        data: {
          id: id,
          userid: ids,
          booleanAccountstatus: index
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      });
      pro
        .then(result => {
          // 删除成功
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          // this.chaxun()
          // this.getArticleList()
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('更改员工状态失败：' + err);
        });
    },
    // 删除
    del(id) {
      // console.log(id)
      // 确认事情
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/teacher/deleteEduTeacher/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        pro
          .then(result => {
            // 删除成功
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.chaxun();
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('删除员工失败：' + err);
          });
      });
    },
    guanli(e) {
      // console.log(e)
      this.xuanze = e.name;
    },
    guanli1(e) {
      // console.log(e)
      this.xuanze1 = e.name;
      this.xuanze1_1 = e.code;
    },
    guanli1_1(e) {
      // console.log(e)
      this.xuanze3 = e.name;
      this.xuanze1_2 = e.code;
    },
    guanli2(e, c) {
      // console.log(c)
      if (this.list[0].name === '请选择您所在的班级（可多选）') {
        this.list[0].name = e.name;
        this.list[0].id = e.id;
        // this.current = c
        if (this.list[0].name !== '请选择您所在的班级（可多选）') {
          this.yang = false;
        }
      } else if (this.list[0].name !== '请选择您所在的班级（可多选）') {
        if (JSON.stringify(this.list).indexOf(JSON.stringify(e)) === -1) {
          this.list.push({ name: e.name, id: e.id });
          // this.current.push(c)
        } else {
          this.$message.error('您选择的班级已在您的选择中！');
        }
      }
      // console.log(this.list)
    },
    guanli2_1(e, c) {
      if (this.lists[0].name === '请选择您所在的班级（可多选）') {
        this.lists[0].name = e.name;
        this.lists[0].id = e.id;
        // this.current = c
        if (this.lists[0].name !== '请选择您所在的班级（可多选）') {
          this.yang_1 = false;
        }
      } else if (this.lists[0].name !== '请选择您所在的班级（可多选）') {
        if (JSON.stringify(this.lists).indexOf(JSON.stringify(e)) === -1) {
          this.lists.push({ name: e.name, id: e.id });
          // this.current.push(c)
        } else {
          this.$message.error('您选择的班级已在您的选择中！');
        }
      }
      // console.log(this.list)
    },
    guanli3(e) {
      // console.log(e)
      for (let i in this.list) {
        if (this.list[i].id === e) {
          this.list.splice(i, 1);
        }
      }
      if (this.list.length <= 0) {
        this.yang = true;
        this.list.push({ name: '请选择您所在的班级（可多选）', id: '' });
      }
      // this.form.classid = this.list[0].id
      // console.log(this.form.classid)
    },
    guanli3_1(e) {
      // console.log(e)
      for (let i in this.lists) {
        if (this.lists[i].id === e) {
          this.lists.splice(i, 1);
        }
      }
      if (this.lists.length <= 0) {
        this.yang_1 = true;
        this.lists.push({ name: '请选择您所在的班级（可多选）', id: '' });
      }
      // this.form.classid = this.list[0].id
      // console.log(this.form.classid)
    },
    xinjian() {
      this.dialogTableVisible = true;
      this.banji();
    }
  }
};
</script>

<style lang="less">
.mains {
  .campus {
    // width: 28px;
    // height: 1vw;
    font-family: PingFang SC;
    font-size: 0.73vw !important;
    color: #666666;
    font-weight: 400;
    line-height: 1vw;
    margin-bottom: 0.5vw;

    a {
      text-decoration: none;
      color: #666;
    }

    span {
      margin: 0 0.5vw 0 8px;
    }
  }

  .xiaoqu {
    width: 100%;
    position: relative;
    .el-link.el-link--default {
      color: #00a6e6;
    }
    .el-link.is-underline:hover:after {
      border-bottom: 0;
    }
    .grid-content {
      border-radius: 8px;
      background: #fff;
      padding: 0 1.3vw;
      .el-dialog__body {
        padding: 19px 40px 15px 40px;
      }
      .el-dialog {
        width: 600px !important;
        position: relative;
        top: 40%;
        margin: 0 auto !important;
        transform: translateY(-50%);
        .form_1_1 {
          margin-left: 0;
          .xingbie1 {
            position: absolute;
            top: 178px;
            right: 62px;
            i {
              img {
                position: absolute !important;
                top: 0.26042vw !important;
                left: -64px !important;
              }
            }
            .el-radio {
              margin-right: 20px;
            }
          }
          .el-form-item {
            margin-bottom: 8px;
            i {
              img {
                position: absolute;
                top: 0.26042vw;
                left: -94px;
              }
            }
            .el-button--primary:hover {
              border: 1px solid #0094ce;
            }
            .el-input__inner:focus {
              border-color: #409eff;
              outline: 0;
            }
            .xuanze1 {
              position: absolute;
              top: -18px;
              left: 0;
              span {
                position: absolute;
                top: 0;
                left: 20px;
              }
            }
            .el-dropdown .el-button--primary {
              width: 100px;
              overflow: hidden;
            }
            .banji .el-button--primary {
              width: 360px;
              .yang1 {
                // position: absolute;
                left: 0;
                .yang11 {
                  display: none;
                }
              }
              .yang2 {
                left: 0;
                height: 18px;
                line-height: 18px;
                background: #f2f2f2;
                color: #00a6e6;
                margin-top: 4px;
                padding: 3px 8px;
                margin-right: 20px;
                position: static;
                .yang22 {
                  margin-left: 5px;
                  width: 9px;
                }
              }
            }
            .el-input__inner {
              color: #666;
            }
          }
          .queding {
            margin: 20px 0 0 230px;
            .el-button--primary {
              width: 70px;
              height: 26px;
              line-height: 2px;
              font-size: 13px;
              border-radius: 5px;
            }
            .el-button--default {
              width: 70px;
              height: 26px;
              line-height: 2px;
              font-size: 13px;
              border-radius: 5px;
              margin-left: 30px;
            }
          }
          .el-form-item__label {
            padding: 0 17px 0 0;
            color: #cccccc;
          }
          input {
            width: 360px;
            font-size: 12px;
            height: 28px;
            line-height: 28px;
          }
          .el-input__inner {
            border: 1px solid #ccc;
          }
          input::-webkit-input-placeholder,
          textarea::-webkit-input-placeholder {
            color: #666 !important;
          }
          .genggai {
            position: absolute;
            margin: -35px 0 0 248px;
            color: rgb(224, 9, 9);
            font-size: 10px;
            // top: 97px;
            // right: 80px;
          }
          .el-dropdown .el-button--primary {
            width: 90px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #666666;
            background-color: #fff;
            border-color: #ccc;
            border-radius: 3px;
            box-shadow: none;
          }
          .el-button--primary:hover {
            border: 1px solid #ccc;
          }

          .jinzhishuru {
            input {
              background: rgba(242, 242, 242, 0.6);
            }
          }
        }
      }
      .el-dialog__header {
        font-weight: bold;
        line-height: 1.3vw;
        color: rgba(51, 51, 51, 1);
        letter-spacing: 2px;
        font-size: 0.93vw;
        text-align: left;
        border-bottom: 0.5px solid #dedede;
        width: 28.125vw !important;
        margin: 0 auto;
        padding: 25px 0px 15px 0;

        .el-dialog__headerbtn {
          position: absolute;
          top: 26px;
          right: 30px;
        }
        .el-dialog__headerbtn .el-dialog__close {
          color: #000;
          font-weight: bold;
          line-height: 2;
        }

        .el-dialog__title {
          padding-left: 13px;
        }

        .el-dialog__title:before {
          content: ' ';
          border-left: 3px solid #0090c9;
          display: inline-block;
          height: 0.93vw;
          position: absolute;
          top: 29px;
          left: 30px;
        }
      }

      .xiaoqu_1 {
        font-size: 0.83vw;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 0.93vw;
        color: rgba(51, 51, 51, 1);
        letter-spacing: 1px;
        border-left: 3px solid #0090c9;
        padding-left: 0.6vw;
        position: relative;
        top: 5px;
        left: 5px;
        margin: 1vw 0 1vw 0;
      }

      .chakanss {
        font-size: 14px;
        color: #ccc;
        margin-bottom: 20px;
        span {
          margin-left: 10px;
          color: #333333;
        }
      }

      .buttons {
        margin-top: 0.5vw;
        background: #00a6e6;
      }

      .el-button {
        font-size: 0.73vw;
        // padding: 0.6vw 1.05vw;
      }
      .caozuo {
        padding: 0;
      }

      .pickers {
        width: 14.02vw;
        height: 2.05vw;
        margin-right: 1.55vw;
        font-size: 0.73vw;
      }

      .sousuo {
        float: right;
        margin-top: 0.5vw;
        font-size: 0.73vw;

        .el-dropdown .el-button--primary {
          color: #666666;
          background-color: #fff;
          border-color: #ccc;
        }
        .el-button--primary:hover {
          border: 1px solid #0094ce;
        }
        .xuanze {
          padding-left: 15px;
          padding-right: 15px;
          width: 6.72917vw;
          margin-right: 30px !important;
          z-index: 9999;
          text-align: left;
          i {
            float: right;
          }
        }
        .el-icon--right {
          margin-left: 5px;
        }
        .el-input {
          width: 11.45vw;
          height: 32px;
          margin-right: 1.55vw;
          font-size: 0.73vw;
        }

        .el-button {
          margin: 0;
          font-size: 0.73vw;
        }

        .el-range-editor.el-input__inner {
          padding: 0.155vw 0.52vw;
        }

        .el-date-editor .el-range__icon {
          font-size: 0.73vw;
          margin-left: -5px;
          line-height: 1.8vw;
        }

        .el-date-editor .el-range-input,
        .el-date-editor .el-range-separator {
          font-size: 0.73vw;
        }

        .el-date-editor .el-range-separator {
          padding: 0 0.25vw;
          line-height: 1.64vw;
        }

        .el-input__inner {
          height: 2.085vw;
          line-height: 2.085vw;
        }
      }
      .zsbg1 {
        margin: 1.3vw 0 30px 0 !important;
      }
      .zsbg {
        margin: 1.3vw 0 80px 0;

        .el-table--border td,
        .el-table--border th,
        .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
          border-right: none;
          text-align: center;
        }

        .el-table--enable-row-hover .el-table__body tr:hover > td {
          background-color: #fff !important;
        }

        .el-table--border,
        .el-table--group {
          border: 1px solid #cccccc;
        }

        .el-table {
          font-size: 0.73vw;
          color: #666666;

          .el-table_1_column_1 {
            text-align: left;
            padding-left: 5%;
          }
          .el-table_2_column_8 {
            text-align: left;
            padding-left: 5%;
          }

          .el-table_1_column_2 {
            text-align: left;
            padding-left: 1%;
          }
          .el-table_2_column_9 {
            text-align: left;
          }

          .el-table_1_column_4 {
            .chakan {
              color: #00a6e6;
            }
          }

          th {
            background: #eee;
            color: #333333;
            height: 60px;
            font-size: 15px;
          }

          tr {
            height: 60px;
          }

          td,
          th.is-leaf {
            border-bottom: 1px solid #cccccc;
          }
        }
      }

      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        margin: 0 5px;
        background-color: #fff;
        border: 1px solid #ccc;
        color: #606266;
        min-width: 1.55vw;
        border-radius: 3px;
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #409eff;
        color: #fff !important;
        border: none !important;
      }

      .el-pager {
        li:hover {
          color: #00a6e6 !important;
          border: 1px solid #00a6e6 !important;
        }
      }

      .el-pagination__editor.el-input {
        width: 35px;
      }

      .el-pagination {
        position: absolute;
        bottom: 4%;
        right: 1.5%;
      }
    }
  }
  .juese {
    margin-top: 20px;
  }
}

// .el-dropdown-menu,
.dropdowns {
  margin: 0;
  padding: 0;
  border: 0;
  position: relative;
  // top: 208px !important;
  left: 1305px !important;
  z-index: 0 !important;
  .el-dropdown-menu__item {
    font-size: 0.73vw;
    color: #666;
    line-height: 1.5625vw;
    margin: 0 auto;
    width: 6vw;
    padding: 0 0 0 15px !important;
    height: 34px;
  }
  li:visited {
    color: #00a6e6;
  }
  .el-dropdown-menu__item:first-child {
    border-radius: 5px 5px 0 0;
  }
  .el-dropdown-menu__item:nth-last-child(2) {
    border-radius: 0 0 5px 5px;
  }
  .el-dropdown-menu__item:hover {
    background: #00a6e6;
    color: #fff;
  }
  .popper__arrow {
    border: 0px solid #ccc !important;
  }
}
.dropdownss {
  margin: 0;
  padding: 0;
  border: 0;
  position: relative;
  // top: 345px !important;
  left: 818px !important;
  // z-index: 999 !important;
  .el-dropdown-menu__item {
    font-size: 0.73vw;
    color: #666;
    line-height: 1.5625vw;
    margin: 0 auto;
    width: 84px;
    padding: 0 0 0 15px !important;
    height: 34px;
  }

  .el-dropdown-menu__item:first-child {
    border-radius: 5px 5px 0 0;
  }
  .el-dropdown-menu__item:nth-last-child(2) {
    border-radius: 0 0 5px 5px;
  }
  .el-dropdown-menu__item:hover {
    background: #00a6e6;
    color: #fff;
  }
  .popper__arrow {
    border: 0px solid #ccc !important;
  }
}

.dropdownsss {
  margin: 0;
  padding: 0;
  border: 0;
  position: fixed;
  // top: 391px !important;
  left: 818px !important;
  height: 170px;
  // z-index: 999 !important;
  .el-dropdown-menu__item {
    font-size: 0.73vw;
    color: #666;
    line-height: 1.5625vw;
    margin: 0 auto;
    width: 344px;
    padding: 0 0 0 15px !important;
    height: 34px;
    .yang1_1 {
      position: absolute;
      right: 15px;
      margin-top: 10px;
    }
  }
  .yang1_2 {
    color: #00a6e6;
  }
  .el-dropdown-menu__item:first-child {
    border-radius: 5px 5px 0 0;
  }
  .el-dropdown-menu__item:nth-last-child(2) {
    border-radius: 0 0 5px 5px;
  }
  .el-dropdown-menu__item:hover {
    background: #00a6e6;
    color: #fff;
  }
  .popper__arrow {
    border: 0px solid #ccc !important;
  }
}

.el-popper .popper__arrow::after {
  border-width: 0 !important;
}
</style>
